import React from "react";
import { Outlet } from "react-router-dom";
import LanguagePicker from "@/components/common/language-picker";
import { Styled } from "./styles";

const Auth: React.FC = () => {
    return (
        <Styled.Container>
            <LanguagePicker
                color="white"
                style={{ position: "absolute", top: "2%", right: "2%" }}
            />

            <Outlet />
        </Styled.Container>
    );
};

export default Auth;
